import { render, staticRenderFns } from "./ShippingAddFormFooter.vue?vue&type=template&id=9daf208e"
import script from "./ShippingAddFormFooter.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports